/**
 * Get the index of the item in the animation offset array
 */ const getAnimationOffsetIndex = (columnCount, itemNumber, maxItemsPerColumn)=>itemNumber - columnCount * maxItemsPerColumn;

export { getAnimationOffsetIndex };
